import config from 'config';

const LOAD = 'football/competition/LOAD';
const LOAD_SUCCESS = 'football/competition/LOAD_SUCCESS';
const LOAD_FAIL = 'football/competition/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result
      };
    }
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.football
      && globalState.football.competition
      && globalState.football.competition.loading;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(config.api.football.competitionList)
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/competitions.js